import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const TRUST_PORTAL_FEATURES_VALUES = [
  {
    value: 'documents',
    label: 'Restricted Documents',
  },
  {
    value: 'ti',
    label: 'TI',
  },
  // TODO enable as necessary
  /*{
    value: 'questionnaire',
    label: 'Questionnaire',
  },*/
]

export const TrustPortalFeaturesDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <FilterDropdown
        filterParam={FilterParam.TRUST_PORTAL_FEATURES}
        filterName={FilterName.TRUST_PORTAL_FEATURES}
        filterValues={TRUST_PORTAL_FEATURES_VALUES}
        isNested={isNested}
      />
    )
  },
)
